import { useMemo } from 'react';
import { useQuery } from 'urql';

import {
  TAXONOMY_LIST_QUERY,
  type TaxonomyListQuery,
  type TaxonomyType,
} from '@revelio/data-access';

const EMPTY_TAXONOMIES: TaxonomyListQuery['taxonomyList']['taxonomies'] = [];

export const useTaxonomyList = ({
  taxonomyType,
  taxonomyVersion,
  pause = false,
}: {
  taxonomyType: TaxonomyType;
  taxonomyVersion?: string;
  pause?: boolean;
}) => {
  const variables = useMemo(
    () => ({
      taxonomyType,
      taxonomyVersion,
    }),
    [taxonomyType, taxonomyVersion]
  );
  const context = useMemo(
    () => ({
      priority: 'low' as const,
      skipGlobalErrorHandling: true,
    }),
    []
  );
  const [{ data, fetching, error }] = useQuery({
    query: TAXONOMY_LIST_QUERY,
    variables,
    pause,
    requestPolicy: 'cache-first',
    context,
  });

  return {
    taxonomies: data?.taxonomyList.taxonomies ?? EMPTY_TAXONOMIES,
    hasData: data?.taxonomyList !== undefined,
    fetching,
    error,
  };
};
